function confirmPassword(matchPassword: string) {
  return [
    notEmpty(),
    (v: string) => v === matchPassword || 'Passwords must match',
  ]
}

function notEmpty() {
  return (v: string) => !!v?.toString() || 'Required'
}

export function useRules() {
  return {
    confirmPassword,
    email: [
      notEmpty(),
      (v: string) => /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/.test(v) || 'Not a valid email',
    ],
    notEmpty: notEmpty(),
    password: [
      notEmpty(),
      (v: string) => (v && v.length >= 8) || 'Must be at least 8 characters',
      (v: string) => (v && v.search(/[A-Z]/) >= 0) || 'Needs 1 uppercase letter',
      (v: string) => (v && v.search(/[a-z]/) >= 0) || 'Needs 1 lowercase letter',
      (v: string) => (v && v.search(/\d/) >= 0) || 'Needs 1 number 0-9',
      (v: string) => (v && v.search(/[!@#$%^&*]/) >= 0) || 'Needs 1 special character !@#$%^&*',
    ],
  }
}
